import { Component, ViewContainerRef, ViewEncapsulation, ElementRef } from '@angular/core';
import { ToastsManager } from "ng2-toastr";

import "jquery";

import { ConfigService } from "./services/configService";
@Component({
    selector: 'my-app',
    styleUrls: ['../node_modules/bootstrap/dist/css/bootstrap.css',
        '../theme/css/material-dashboard.css',
        '../node_modules/ng2-toastr/ng2-toastr.css',
        '../node_modules/perfect-scrollbar/dist/css/perfect-scrollbar.css',
        "../node_modules/@swimlane/ngx-dnd/release/index.css",
    ],
    template: '<router-outlet></router-outlet>',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {
    constructor(private toastr: ToastsManager, vcr: ViewContainerRef, private configService: ConfigService) {
        this.toastr.setRootViewContainerRef(vcr);
    }

    ngAfterViewInit(): void {
        if (!String.isNullOrEmpty(this.configService.config.GTagId)) {
            // by task https://jira.ak-tech.org/browse/BB-2517
            // const s = document.createElement("script");
            // s.src = `https://www.googletagmanager.com/gtag/js?id=${this.configService.config.GUATagId ? this.configService.config.GUATagId : this.configService.config.GTagId}`;
            // s.async = true;
            //
            // document.head.insertBefore(s, document.head.firstChild);

            const s2 = document.createElement("script");
            s2.type = "text/javascript";
            s2.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
                {'gtm.start': new Date().getTime(),event:'gtm.js'});
                var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${this.configService.config.GTagId}');`;
            document.head.insertBefore(s2, document.head.firstChild);

            const s3= document.createElement("script");
            s3.type = "text/javascript";
            s3.innerHTML = `  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());


  gtag('config', '${this.configService.config.GUATagId ? this.configService.config.GUATagId : this.configService.config.GTagId}');
            `;
  
            document.head.insertBefore(s3, document.head.firstChild);


        }

        //removes this by request in BB-1791
        //this.initZendesk();
    }

    private initZendesk(): void {
        const zendeskScript = document.createElement("script");
        zendeskScript.type = "text/javascript";
        zendeskScript.innerHTML = `/*<![CDATA[*/window.zEmbed||function(e,t){var n,o,d,i,s,a=[],r=document.createElement("iframe");
        window.zEmbed=function(){a.push(arguments)},window.zE=window.zE||window.zEmbed,r.src="javascript:false",r.title="",r.role="presentation",
        (r.frameElement||r).style.cssText="display: none",d=document.getElementsByTagName("script"),
        d=d[d.length-1],d.parentNode.insertBefore(r,d),i=r.contentWindow,s=i.document;try{o=s}catch(e){
        n=document.domain,r.src='javascript:var d=document.open();d.domain="'+n+'";void(0);',o=s}o.open()._l=function(){var e=this.createElement("script");n&&(this.domain=n),
        e.id="js-iframe-async",
        e.src="https://assets.zendesk.com/embeddable_framework/main.js",
        this.t=+new Date,this.zendeskHost="borderbuddy.zendesk.com",this.zEQueue=a,this.body.appendChild(e)},o.write('<body onload="document._l();">'),o.close()}();
            /*]]>*/`;
        document.head.insertBefore(zendeskScript, document.head.firstChild);
    }

}


// WEBPACK FOOTER //
// ./app/app.component.ts